export const SubsidiaryPmsUserKind = {
  PmsIntegration: 0,
  HotelContact: 1
}

export const subsidiaryPmsUserKindLabels = {
  [SubsidiaryPmsUserKind.PmsIntegration]: 'PMS integration',
  [SubsidiaryPmsUserKind.HotelContact]: 'Hotel contact',
  PmsIntegration: 'PMS integration',
  HotelContact: 'Hotel contact'
}

export const getSubsidiaryPmsUserKind = user => user?.kind ?? user?.Kind

export const isHotelContactPmsUser = user => {
  const kind = getSubsidiaryPmsUserKind(user)
  return kind === SubsidiaryPmsUserKind.HotelContact || kind === 'HotelContact'
}

export const getSubsidiaryPmsUserKindLabel = user => {
  const kind = getSubsidiaryPmsUserKind(user)
  return subsidiaryPmsUserKindLabels[kind] ?? subsidiaryPmsUserKindLabels[SubsidiaryPmsUserKind.PmsIntegration]
}

export const sortSubsidiaryPmsUsersByKind = users =>
  [...(users || [])].sort((a, b) => {
    const aRank = isHotelContactPmsUser(a) ? 0 : 1
    const bRank = isHotelContactPmsUser(b) ? 0 : 1
    return aRank - bRank
  })
